import { currencies, priceBystaffGroups } from '@/mainData';

const roundNumber = number => {
  const rest = number%1;

  if (!rest) return number;

  return parseInt(number) + Math.round(rest * 10) / 10;
}

const convertToCurrencyPrice = (price, currency) => {
  if (currency === 'uah') {
    return price * currencies.usd.price;
  } else if (currency === 'eur') {
    // double conversion
    return price * currencies.usd.price / currencies.eur.price;
  } else {
    return price;
  }
};

const calcRecruiterFullPrice = ({ recruiters, months, currency }) => {
  const priceForOne = convertToCurrencyPrice(45, currency);

  return recruiters * priceForOne * months;
}

const calcHrFullPrice = ({ selectedGroup, months, currency }) => {
  const groupPrice = convertToCurrencyPrice(priceBystaffGroups[selectedGroup].price, currency);

  return groupPrice * months;
}

const calAllPrices = ({ fullPrice, months, discount }) => {
  const withDiscount = discount ? fullPrice * (1 - discount / 100) : 0;
  const perMonth = (withDiscount || fullPrice) / months;

  return {
    withDiscount: roundNumber(withDiscount),
    fullPrice: roundNumber(fullPrice),
    perMonth: roundNumber(perMonth),
  };
}

export function calcRecruiterPrices({ recruiters, months, discount, currency }) {
  const fullPrice = calcRecruiterFullPrice({ recruiters, months, currency });

  return calAllPrices({ fullPrice, months, discount });
}

export function calcHrPrices({ selectedGroup, months, discount, currency }) {
  const fullPrice = calcHrFullPrice({ selectedGroup, months, currency });

  return calAllPrices({ fullPrice, months, discount });
}

export function calcAllIncludedPrices({ selectedGroup, recruiters, months, discount, currency }) {
  const recruiterFullPrice = calcRecruiterFullPrice({ recruiters, months, currency });
  const hrFullPrice = calcHrFullPrice({ selectedGroup, months, currency });
  const fullPrice = recruiterFullPrice + hrFullPrice;

  return calAllPrices({ fullPrice, months, discount });
}